<script setup lang="ts">
import { formatDate } from '@/utils/dateUtils';
import { inject, Ref } from 'vue';
import { getCurrentLocale } from '@/i18n';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import TableColumn from 'primevue/column';

const dialogRef = inject('dialogRef') as Ref;
const versions = dialogRef.value.options.data.versions;
const onPreview = dialogRef?.value?.options.emits.onPreview;
const onRevert = dialogRef?.value?.options.emits.onRevert;
const onExport = dialogRef?.value?.options.emits.onExport;
const onClose = dialogRef?.value?.options.emits.onClose;

const currentLanguage = getCurrentLocale();

const handlePreview = (fileName: string) => {
  onPreview(fileName);
};

const handleExportVersion = (fileName: string) => {
  onExport(fileName);
};

const handleRevertVersion = (fileName: string) => {
  onRevert(fileName);
};

const handleCloseModal = () => {
  onClose();
};
</script>
<template>
  <div>
    <div class="revert-modal">
      <DataTable :value="versions" class="w-full" :rows="5" paginator editMode="row" showGridlines>
        <TableColumn :show-filter-operator="false" :show-add-button="false" field="fileName" :header="$t('management.file_name')">
          <template #body="{ data }">
            {{ data.fileName }}
          </template>
        </TableColumn>
        <TableColumn :show-filter-operator="false" :show-add-button="false" field="importName" :header="$t('management.import_name')">
          <template #body="{ data }">
            {{ data.importName }}
          </template>
        </TableColumn>
        <TableColumn :show-filter-operator="false" :show-add-button="false" field="importEmail" :header="$t('management.import_email')">
          <template #body="{ data }">
            {{ data.importEmail }}
          </template>
        </TableColumn>
        <TableColumn :show-filter-operator="false" :show-add-button="false" field="createdDate" :header="$t('management.date_of_import')">
          <template #body="{ data }">
            {{ formatDate(data.createdDate, 'dd-LLL-yyyy', true, currentLanguage) }}
          </template>
        </TableColumn>
        <TableColumn :show-filter-operator="false" :show-add-button="false" field="createdDate" :header="$t('management.time_of_import')">
          <template #body="{ data }">
            {{ formatDate(data.createdDate, 'hh:mm:ss', true, currentLanguage) }}
          </template>
        </TableColumn>
        <TableColumn :header="$t('common.action')" class="flex justify-content-center">
          <template #body="{ data }">
            <div class="flex gap-1 flex-wrap w-8rem">
              <Button id="btn_preview_version" :label="$t('common.preview')" class="min-w-9rem p-button-outlined p-button-xs border-noround" @click="handlePreview(data?.fileName)" />
              <Button id="btn_export_version" :label="$t('common.buttons.export')" class="button_export min-w-9rem p-button-outlined p-button-xs border-noround" @click="handleExportVersion(data?.fileName)" />
              <Button id="btn_revert_version" :label="$t('common.buttons.revert')" class="min-w-9rem p-button-outlined p-button-xs border-noround" @click="handleRevertVersion(data?.fileName)" />
            </div>
          </template>
        </TableColumn>
      </DataTable>
    </div>
    <div class="mt-1 text-center">
      <Button id="btn_close" :label="$t('common.buttons.close')" @click="handleCloseModal()" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep(.p-button-xs) {
  font-size: 0.775rem;
  padding: 0.25rem 0.5rem;
}
.button_export {
  :enabled:hover {
    background: #00526e;
    color: white;
    border: 1px solid;
  }
  ::v-deep() {
    .p-button {
      font-size: 0.775rem;
      padding: 0.25rem 0.5rem;
      background-color: transparent;
      color: #00526e;
      border: 1px solid;
      border-radius: 0;
      min-width: 8rem;
    }
    .p-button-icon {
      display: none;
    }
  }
}
</style>
